(function () {
  function initAboutZen(root) {
    var blocks = root.querySelectorAll('.univ-about-zen__block');

    if (!('IntersectionObserver' in window) || !blocks.length) {
      blocks.forEach(function (block) {
        block.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    blocks.forEach(function (block) {
      observer.observe(block);
    });
  }

  function init() {
    document.querySelectorAll('.univ-about-zen').forEach(function (root) {
      if (root._aboutZenInit) return;
      root._aboutZenInit = true;
      initAboutZen(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
